<template>
  <ul v-if="password" class="password-checklist">
    <li v-for="rule in rules" :key="rule.key" :class="{ passed: rule.passed }">
      <i :class="rule.passed ? 'el-icon-check' : 'el-icon-close'"></i>
      {{ rule.label }}
    </li>
  </ul>
</template>

<script>
export default {
  name: 'PasswordChecklist',
  props: {
    password: { type: String, default: '' },
  },
  computed: {
    rules() {
      const v = this.password || '';
      return [
        { key: 'len',     label: '至少 12 個字元',                   passed: v.length >= 12 },
        { key: 'upper',   label: '至少一個大寫字母（A–Z）',           passed: /[A-Z]/.test(v) },
        { key: 'lower',   label: '至少一個小寫字母（a–z）',           passed: /[a-z]/.test(v) },
        { key: 'digit',   label: '至少一個數字（0–9）',               passed: /[0-9]/.test(v) },
        { key: 'special', label: '至少一個特殊字元（!@#$%^&* 等）',   passed: /[^A-Za-z0-9]/.test(v) },
      ];
    },
  },
};
</script>

<style scoped>
.password-checklist {
  list-style: none;
  padding: 4px 0 0;
  margin: 0;
  font-size: 12px;
}
.password-checklist li {
  padding: 2px 0;
  color: #f56c6c;
}
.password-checklist li.passed {
  color: #67c23a;
}
.password-checklist i {
  margin-right: 4px;
  font-size: 11px;
}
</style>
